import React from 'react'
import styled, { RuleSet } from 'styled-components'
import coupon_thumbnail_default from 'src/assets/images/coupon_thumbnail/coupon_thumbnail_circle_default.png'
import Skeleton from 'react-loading-skeleton'

export interface ImageProps {
  src: string
  margin?: string
  style?: RuleSet<object>
}

const CouponCircleImage = ({ src, margin, style }: ImageProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = coupon_thumbnail_default
  }

  return (
    <ImageWrap
      src={src}
      onError={handleImageError}
      alt="coupon img"
      $margin={margin}
      $style={style}
      as={!!src ? 'img' : Skeleton}
    />
  )
}
export default CouponCircleImage

const ImageWrap = styled.img<{ $margin?: string; $style?: RuleSet<object> }>`
  width: 72px;
  min-width: 72px;
  height: 72px;
  border-radius: 100px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  object-fit: contain;
  margin: ${(props) => props.$margin || '0 auto '};
  background-color: var(--white);
  ${(props) => props.$style};
`
